import { ContainerModule } from 'inversify';
import quizSessionStoreModule, { QuizSessionStoreModuleSymbol } from './quiz-session-store-module';
import { QuizSessionQuery, QuizSessionQuerySymbol } from './quiz-session-query'

export const quizSessionStateModule = new ContainerModule((bind) => {
  bind(QuizSessionStoreModuleSymbol).toConstantValue(quizSessionStoreModule)
  bind<QuizSessionQuery>(QuizSessionQuerySymbol).toDynamicValue(c => c.container.get(QuizSessionStoreModuleSymbol))
});
